export const EMPTY_ARRAY = []
export const FRONT_KEY = 'FRONT_KEY'
export const EMPTY_ARRAY = []
export const FRONT_KEY = 'FRONT_KEY'
